<form [formGroup]="customerDetailsForm">
	<h2 class="applicant-details">Applicant details</h2>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('firstName')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="firstName"
			>
				{{ 'COMMON.FIRST_NAME' | translate }}
			</label>
		</h3>
		@if(showErrors('firstName')){
		<p id="first-name-error" class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.IS_REQUIRED'
					| translate : { value: 'COMMON.FIRST_NAME' | translate }
			}}
		</p>
		}

		<input
			formControlName="firstName"
			class="govuk-input govuk-input--inverse"
			id="firstName"
			name="firstName"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('firstName')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('lastName')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="lastName"
			>
				{{ 'COMMON.LAST_NAME' | translate }}
			</label>
		</h3>
		@if(showErrors('lastName')){
		<p id="last-name-error" class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.IS_REQUIRED'
					| translate : { value: 'COMMON.LAST_NAME' | translate }
			}}
		</p>
		}

		<input
			formControlName="lastName"
			class="govuk-input govuk-input--inverse"
			id="lastName"
			name="lastName"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors(';astName')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('emailAddress')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="emailAddress"
			>
				{{ 'COMMON.EMAIL_ADDRESS' | translate }}
			</label>
		</h3>
		@if(showErrors('emailAddress')){
		<p id="email-error" class="govuk-error-message">
			<!-- required -->
			@if(form['emailAddress']?.errors?.['required']) {
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.IS_REQUIRED'
					| translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
			}}
			} 
			@if(form['emailAddress']?.errors?.['email']){ 
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.INVALID'
					| translate : { value: 'COMMON.EMAIL_ADDRESS' | translate }
			}}
			}
		</p>
		}

		<input
			formControlName="emailAddress"
			class="govuk-input govuk-input--inverse"
			id="emailAddress"
			name="emailAddress"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('emailAddress')
			}"
		/>

		@if(adminJourney){
		<fieldset class="govuk-fieldset" aria-describedby="emailAddress_consent">
			<br />
			<div class="govuk-checkboxes" data-module="govuk-checkboxes">
				<div class="govuk-checkboxes__item">
					<input
						formControlName="emailAddress_consent"
						class="govuk-checkboxes__input"
						id="emailAddress_consent_box"
						name="emailAddress_consent"
						type="checkbox"
					/>

					<label
						class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
						for="emailAddress_consent_box"
					>
						{{ 'COMMON.ADMIN_EMAIL_HINT' | translate }}
					</label>
				</div>
			</div>
			@if(showErrors('emailAddressConsent')){
			<p class="govuk-error-message">
				<span class="govuk-visually-hidden">Error:</span> As we are going to be
				using email as the point of reminding customers about their ceremony, we
				really need to ensure that this is correct at the booking.
			</p>
			}
		</fieldset>
		}
	</div>

	@if(adminJourney){
	<div
		class="govuk-notification-banner"
		role="region"
		aria-labelledby="govuk-notification-banner-title"
		data-module="govuk-notification-banner"
	>
		<div class="govuk-notification-banner__header">
			<h2
				class="govuk-notification-banner__title"
				id="govuk-notification-banner-title"
			>
				ADMIN GUIDANCE: Email address required
			</h2>
		</div>
		<div class="govuk-notification-banner__content">
			<p
				aria-label="Notification message"
				class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
				style="font-weight: 500 !important; font-size: 19px !important"
			>
				{{ 'COMMON.ADMIN_EMAIL_NOTIFICATION' | translate }} <br /><br />
				{{ 'COMMON.ADMIN_EMAIL_NOTIFICATION_TWO' | translate }}
			</p>
		</div>
	</div>
	}

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('contactNumber')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="contactNumber"
			>
				{{ 'COMMON.CONTACT_NUMBER' | translate }}
			</label>
		</h3>
		<div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
			{{ 'COMMON.PHONE_HINT' | translate }}
		</div>
		<div id="event-name-hint" class="govuk-hint govuk-hint--inverse">
			{{ 'COMMON.PHONE_HINT_TWO' | translate }}
		</div>
		@if(showErrors('contactNumber')){
		<p id="event-name-error" class="govuk-error-message">
			<!-- required -->
			@if(form['contactNumber']?.errors?.['required']){
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.IS_REQUIRED'
					| translate : { value: 'COMMON.CONTACT_NUMBER' | translate }
			}}
			} 
			<!-- pattern -->
			@if(form['contactNumber']?.errors?.['pattern']){
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.INVALID'
					| translate : { value: 'COMMON.CONTACTNUMBER' | translate }
			}}
			} @if(form['contactNumber']?.errors?.['minlength']){
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.INVALID'
					| translate : { value: 'COMMON.CONTACTNUMBER' | translate }
			}}
			} @if(form['contactNumber']?.errors?.['maxlength']){
			<span class="govuk-visually-hidden">Error:</span>
			{{
				'COMMON.INVALID'
					| translate : { value: 'COMMON.CONTACTNUMBER' | translate }
			}}
			}
		</p>
		}

		<input
			formControlName="contactNumber"
			class="govuk-input govuk-input--inverse"
			id="contactNumber"
			name="contactNumber"
			(keypress)="keyPressNumberField($event)"
			type="text"
			maxlength="15"
			[ngClass]="{
				'govuk-input--error': showErrors('contactNumber')
			}"
		/>
		@if(adminJourney){
		<fieldset class="govuk-fieldset" aria-describedby="contactNumber_consent">
			<br />
			<div class="govuk-checkboxes" data-module="govuk-checkboxes">
				<div class="govuk-checkboxes__item">
					<input
						formControlName="contactNumber_consent"
						class="govuk-checkboxes__input"
						id="contactNumber_consent_box"
						name="contactNumber_consent"
						type="checkbox"
					/>

					<label
						class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
						for="contactNumber_consent_box"
					>
						{{ 'COMMON.ADMIN_CONTACTNUMBER_HINT' | translate }}
					</label>
				</div>
			</div>
			@if(form['contactNumberConsent'].errors){
			<p class="govuk-error-message">
				<span class="govuk-visually-hidden">Error:</span> As we are going to be
				using the contact number as the point of reminding customers about their
				ceremony, we really need to ensure that this is correct at the booking.
			</p>
			}
		</fieldset>
		}
	</div>


	@if(!isInternationalAddress) {
	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('addressPostcodeLookup') || showAddressError
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				for="addressPostcodeLookup"
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				>Address</label
			>
		</h3>

		@if(showErrors('addressPostcodeLookup')) {
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error: </span>
			Invalid postcode.
		</p>
		}
		<input
			[attr.aria-required]="true"
			(keydown.space)="$event.preventDefault()"
			(keydown.spacebar)="$event.preventDefault()"
			aria-label="Enter postcode"
			class="govuk-input govuk-input--width-20 govuk-input--inverse"
			id="addressPostcodeLookup"
			name="addressPostcodeLookup"
			placeholder="Enter postcode"
			formControlName="addressPostcodeLookup"
			type="text"
		/>

		<button
			type="button"
			class="govuk-button govuk-button--inverse form-button"
			data-module="govuk-button"
			(click)="submitPostcode()"
		>
			{{ 'COMMON.FIND_ADDRESS' | translate }}
		</button>

		@if(showAddressError) {
			<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error: </span>
			{{ 'FORM.MISSING_ADDRESS' | translate}}
		</p>
		}
		@if(addresses.length > 0){
		<div
			class="govuk-form-group"
			[ngClass]="{
				'govuk-form-group--error': showErrors('address')
			}"
		>
			<label
				class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
				for="addresses"
			>
				Select address below
			</label>
			@if(showErrors('address') && form['address'] &&
			form['address']?.errors?.['required']) {
				<p id="event-name-error" class="govuk-error-message">
						</p>
			<span class="govuk-visually-hidden">Error:</span>
			{{ 'COMMON.IS_REQUIRED' | translate }}
			
			}
			<select
				aria-required="true"
				formControlName="address"
				class="govuk-select govuk-select--inverse"
				id="addresses"
				name="address"
			>
				<!-- Hidden placeholder shown only when no value is selected -->
				<option value="" disabled selected hidden>Select address</option>

				<ng-container *ngFor="let option of addresses">
					<option [value]="option">
						{{ option }}
					</option>
				</ng-container>
			</select>
		</div>
		}
	</div>
	}

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('isInternationalAddress')
		}"
	>
		@if(!useCheckboxForManualAddress) {
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="isInternationalAddress"
			>
				Can't find your address? Enter it manually
			</label>
		</h3>
		}
		@if(showErrors('isInternationalAddress')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			This field is required.
		</p>
		}
		@if(useCheckboxForManualAddress) {
		<div class="govuk-checkboxes" data-module="govuk-checkboxes">
			<div class="govuk-checkboxes__item">
				<input
					class="govuk-checkboxes__input"
					id="isInternationalAddress-checkbox"
					type="checkbox"
					[checked]="isInternationalAddress"
					(change)="onManualAddressCheckboxChange($event)"
				/>
				<label
					class="govuk-label govuk-checkboxes__label"
					for="isInternationalAddress-checkbox"
				>
					If you can't find your address, please tick to enter it manually here
				</label>
			</div>
		</div>
		} @else {
		<div class="govuk-radios" data-module="govuk-radios">
			<div class="govuk-radios__item">
				<input
					class="govuk-radios__input"
					id="isInternationalAddress-yes"
					type="radio"
					value="true"
					formControlName="isInternationalAddress"
					name="isInternationalAddress"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="isInternationalAddress-yes"
				>
					Yes
				</label>
			</div>
			<div class="govuk-radios__item">
				<input
					class="govuk-radios__input"
					id="isInternationalAddress-no"
					type="radio"
					value="false"
					formControlName="isInternationalAddress"
					name="isInternationalAddress"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="isInternationalAddress-no"
				>
					No
				</label>
			</div>
		</div>
		}
	</div>

	@if(isInternationalAddress) {
	<!-- Add after your existing address form group -->
	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('addressLine1')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="addressLine1"
			>
				Address Line 1
			</label>
		</h3>
		@if(showErrors('addressLine1')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Address Line 1 is required.
		</p>
		}
		<input
			formControlName="addressLine1"
			class="govuk-input govuk-input--inverse"
			id="addressLine1"
			name="addressLine1"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('addressLine1')
			}"
		/>
	</div>

	<div class="govuk-form-group">
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="addressLine2"
			>
				Address Line 2
			</label>
		</h3>
		<input
			formControlName="addressLine2"
			class="govuk-input govuk-input--inverse"
			id="addressLine2"
			name="addressLine2"
			type="text"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('city')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="city"
			>
				Town/City
			</label>
		</h3>
		@if(showErrors('city')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Town/City is required.
		</p>
		}
		<input
			formControlName="city"
			class="govuk-input govuk-input--inverse"
			id="city"
			name="city"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('city')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('postcode')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="postcode"
			>
				Postcode
			</label>
		</h3>
		@if(showErrors('postcode')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Postcode is required.
		</p>
		}
		<input
			formControlName="postcode"
			class="govuk-input govuk-input--inverse"
			id="postcode"
			name="postcode"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('postcode')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('country')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="country"
			>
				Country
			</label>
		</h3>
		@if(showErrors('country')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Country is required.
		</p>
		}
		<input
			formControlName="country"
			class="govuk-input govuk-input--inverse"
			id="country"
			name="country"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('country')
			}"
		/>
	</div>
	}

	@if(showAddressesSameCheck && !disableDelivery) {
		<div class="govuk-form-group" style="margin-bottom: 30px">
		<h3 class="govuk-label-wrapper">
			<label
				for="identicalDeliveryAddress"
				class="govuk-label govuk-label--m govuk-label--m--inverse"
			>
				Is this address the same as the delivery address ?</label
			>
		</h3>
		@if(fieldHints['addressesSameCheck']) {
			<div id="addressesSameCheck-hint" class="govuk-hint">{{ fieldHints['addressesSameCheck'] }}</div>
		}
		<div class="govuk-radios" data-module="govuk-radios">
			<div class="govuk-radios__item" id="identicalDeliveryAddress">
				<input
					class="govuk-radios__input"
					id="identicalDeliveryAddress-yes"
					type="radio"
					value="true"
					formControlName="addressesSameCheck"
					name="addressesSameCheck"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="identicalDeliveryAddress-yes"
				>
					Yes
				</label>
			</div>
			<div class="govuk-radios__item">
				<input
					class="govuk-radios__input"
					id="identicalDeliveryAddress-no"
					type="radio"
					value="false"
					formControlName="addressesSameCheck"
					name="addressesSameCheck"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="identicalDeliveryAddress-no"
				>
					No
				</label>
			</div>
		</div>
	</div>
	}

	@if(showDeliveryAddress){

	@if(!isInternationalDeliveryAddress) {
	<div 
	class="govuk-form-group"
	[ngClass]="{
				'govuk-form-group--error': showErrors('deliveryAddressPostcodeLookup')
			}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				for="deliveryAddressPostcodeLookup"
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				>Delivery Address</label
			>
		</h3>

		@if(showErrors('deliveryAddressPostcodeLookup')) {
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error: </span>
			Invalid postcode.
		</p>
		}
		<input
			[attr.aria-required]="true"
			(keydown.space)="$event.preventDefault()"
			(keydown.spacebar)="$event.preventDefault()"
			aria-label="Enter postcode"
			class="govuk-input govuk-input--width-20 govuk-input--inverse"
			id="deliveryAddressPostcodeLookup"
			name="deliveryAddressPostcodeLookup"
			placeholder="Enter postcode"
			formControlName="deliveryAddressPostcodeLookup"
			type="text"
		/>

		<button
			type="button"
			class="govuk-button govuk-button--inverse form-button"
			data-module="govuk-button"
			(click)="submitDeliveryPostcode()"
		>
			{{ 'COMMON.FIND_ADDRESS' | translate }}
		</button>
		@if(showDeliveryAddressError) {
			<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error: </span>
			{{ 'FORM.MISSING_ADDRESS' | translate}}
		</p>
		}
		@if(deliveryAddresses.length > 0){
		<div
			class="govuk-form-group"
			[ngClass]="{
				'govuk-form-group--error': showErrors('address')
			}"
		>
			<label
				class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
				for="deliveryAddresses"
			>
				Select address below
			</label>
			@if(showErrors('deliveryAddress') &&
			form['deliveryAddress'].errors?.['required']) {
				<p id="event-name-error" class="govuk-error-message">
					<span class="govuk-visually-hidden">Error:</span>
					{{ 'COMMON.IS_REQUIRED' | translate }}
				</p>
			
			}
			<select
				aria-required="true"
				formControlName="deliveryAddress"
				class="govuk-select govuk-select--inverse"
				id="deliveryAddresses"
				name="deliveryAddress"
			>
				<!-- Hidden placeholder shown only when no value is selected -->
				<option value="" disabled selected hidden>Select address</option>

				<ng-container *ngFor="let option of deliveryAddresses">
					<option [value]="option">
						{{ option }}
					</option>
				</ng-container>
			</select>
		</div>
		}
	</div>
	} 

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('isInternationalDeliveryAddress')
		}"
	>
		@if(!useCheckboxForManualAddress) {
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="isInternationalDeliveryAddress"
			>
				Can't find your address? Enter it manually
			</label>
		</h3>
		}
		@if(showErrors('isInternationalDeliveryAddress')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			This field is required.
		</p>
		}
		@if(useCheckboxForManualAddress) {
		<div class="govuk-checkboxes" data-module="govuk-checkboxes">
			<div class="govuk-checkboxes__item">
				<input
					class="govuk-checkboxes__input"
					id="isInternationalDeliveryAddress-checkbox"
					type="checkbox"
					[checked]="isInternationalDeliveryAddress"
					(change)="onManualDeliveryAddressCheckboxChange($event)"
				/>
				<label
					class="govuk-label govuk-checkboxes__label"
					for="isInternationalDeliveryAddress-checkbox"
				>
					If you can't find your address, please tick to enter it manually here
				</label>
			</div>
		</div>
		} @else {
		<div class="govuk-radios" data-module="govuk-radios">
			<div class="govuk-radios__item">
				<input
					class="govuk-radios__input"
					id="isInternationalDeliveryAddress-yes"
					type="radio"
					value="true"
					formControlName="isInternationalDeliveryAddress"
					name="isInternationalDeliveryAddress"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="isInternationalDeliveryAddress-yes"
				>
					Yes
				</label>
			</div>
			<div class="govuk-radios__item">
				<input
					class="govuk-radios__input"
					id="isInternationalDeliveryAddress-no"
					type="radio"
					value="false"
					formControlName="isInternationalDeliveryAddress"
					name="isInternationalDeliveryAddress"
				/>
				<label
					class="govuk-label govuk-radios__label"
					for="isInternationalDeliveryAddress-no"
				>
					No
				</label>
			</div>
		</div>
		}
	</div>

	@if(isInternationalDeliveryAddress) {
	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('deliveryAddressLine1')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="deliveryAddressLine1"
			>
				Delivery Address Line 1
			</label>
		</h3>
		@if(showErrors('deliveryAddressLine1')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Delivery Address Line 1 is required.
		</p>
		}
		<input
			formControlName="deliveryAddressLine1"
			class="govuk-input govuk-input--inverse"
			id="deliveryAddressLine1"
			name="deliveryAddressLine1"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('deliveryAddressLine1')
			}"
		/>
	</div>

	<div class="govuk-form-group">
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="deliveryAddressLine2"
			>
				Delivery Address Line 2
			</label>
		</h3>
		<input
			formControlName="deliveryAddressLine2"
			class="govuk-input govuk-input--inverse"
			id="deliveryAddressLine2"
			name="deliveryAddressLine2"
			type="text"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('deliveryCity')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="deliveryCity"
			>
				Delivery Town/City
			</label>
		</h3>
		@if(showErrors('deliveryCity')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Delivery Town/City is required.
		</p>
		}
		<input
			formControlName="deliveryCity"
			class="govuk-input govuk-input--inverse"
			id="deliveryCity"
			name="deliveryCity"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('deliveryCity')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('deliveryPostcode')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="deliveryPostcode"
			>
				Delivery Postcode
			</label>
		</h3>
		@if(showErrors('deliveryPostcode')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Delivery Postcode is required.
		</p>
		}
		<input
			formControlName="deliveryPostcode"
			class="govuk-input govuk-input--inverse"
			id="deliveryPostcode"
			name="deliveryPostcode"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('deliveryPostcode')
			}"
		/>
	</div>

	<div
		class="govuk-form-group"
		[ngClass]="{
			'govuk-form-group--error': showErrors('deliveryCountry')
		}"
	>
		<h3 class="govuk-label-wrapper">
			<label
				class="govuk-label govuk-label--m govuk-label--m--inverse"
				for="deliveryCountry"
			>
				Delivery Country
			</label>
		</h3>
		@if(showErrors('deliveryCountry')){
		<p class="govuk-error-message">
			<span class="govuk-visually-hidden">Error:</span>
			Delivery Country is required.
		</p>
		}
		<input
			formControlName="deliveryCountry"
			class="govuk-input govuk-input--inverse"
			id="deliveryCountry"
			name="deliveryCountry"
			type="text"
			[ngClass]="{
				'govuk-input--error': showErrors('deliveryCountry')
			}"
		/>
	</div>
	} }
</form>
